import React, { useState } from "react";
import Swal from "sweetalert2";
import { actualizarRatificacion, finalizarApelacion } from "../../utils/Datos";
import { FormularioCalificacionEditable } from "../EtapasDeCalificacion/FormularioCalificacionEditable";
import { InformacionParticipanteProceso } from "../Otros/InformacionParticipanteProceso";
import { Modal } from "../Otros/Modal";

export const FinalizarApelacion = ({
  id_qualifications,
  id_participant,
  idProcess,
}) => {
  const [calificacionEditada, setcalificacionEditada] = useState(null);
  const [cargando, setCargando] = useState(null);
  const [finalizar, setfinalizar] = useState({
    id_qualifications: id_qualifications,
    volumeOfWork: null,
    speedInExecution: null,
    opportunityInExecution: null,
    planningWork: null,
    abilityToExecute: null,
    jobKnowledge: null,
    studies: null,
    serviceCapacity: null,
    trainingVolunteer: null,
    creativityToSolveProblems: null,
    easyIntegration: null,
    permanency: null,
    punctuality: null,
    standardsCompliance: null,
    taskFulfillment: null,
    appeal: {
      id_qualifications: id_qualifications,
      document: {
        name: "",
        contentType: "application/pdf",
        contentByte: ""
      }
    }
  });

  const handleFile=(e)=>{
    console.log(e.target.files);
    console.log(`Selected file - ${e.target.files[0].name}`);  
    let name=e.target.files[0].name;
    let type=e.target.files[0].type;
    

    /**ARCHIVO A BASE 64 */
    var reader = new FileReader();
    reader.readAsDataURL(e.target.files[0]);
    reader.onload = function () {
        let fileBase64 = reader.result.replace("data:application/pdf;base64,", "");
        setfinalizar({
          ...finalizar,
          appeal:{
            id_qualifications: id_qualifications,
            document:{
                name:name,
                contentType:type,
                contentByte:fileBase64
            }
          }
            
          
        })
    };
    reader.onerror = function (error) {
        Swal.fire({
            icon: 'error',
            title: 'Error...',
            text: error
        });

    };
}

  const handleClick = () => {
    /**ACTUALIZA LA CALIFICACIÓN SI CAMBIÓ */
    if (calificacionEditada!==null) {
      actualizarRatificacion(calificacionEditada).then((r) => {
       /* if (r.status) {
          Swal.fire({
            icon: "success",
            title: "Correcto",
            text: "Se ha actualizado la calificación",
          })
        } else {
          Swal.fire({
            icon: "error",
            title: "Error",
            text: "Ha ocurrido un error al enviar los datos " + r.errores[0],
          });
        } */
      });
    }
   
    
    setCargando(true);
    console.log('FINALIZAR',finalizar);
    finalizarApelacion(finalizar).then((respuesta) => {
      //const $ = window.jQuery;
      if (respuesta.status) {
        //$("#m-").modal("hide");
        Swal.fire({
          title: "Listo",
          text: "Apelación finalizada correctamente",
          icon: "success",
          confirmButtonText: "Ok",
        }).then((okay) => {
          if (okay) {
            window.location.href = "/procesoConformidad";
          }
        });
      } else {
        Swal.fire({
          title: "Error",
          text:
            respuesta.errores ??
            "Ocurrió un error, por favor vuelva a intentarlo",
          icon: "error",
          confirmButtonText: "Ok",
        });
      }
      setCargando(false);
    });
  };
  return (
    <>
      <Modal id="m-" title="Finalizar Apelación">
          <div className="row">
                <InformacionParticipanteProceso
                  idProcess={idProcess}
                  id_participant={id_participant}
                  mostrarTitulo={false}
                ></InformacionParticipanteProceso>
                <div className="table-responsive">
                  <FormularioCalificacionEditable
                    mostrarBoton={false}
                    id_participant={id_participant}
                    setcalificacionEditada={setcalificacionEditada}
                    setfinalizar={setfinalizar}
                    finalizar={finalizar}
                  ></FormularioCalificacionEditable>
                </div>
                <div className="col-lg-6 col-sm-12 mb-5 mt-4">
                  <label className="form-label " htmlFor="subir ">
                    Subir acta
                  </label>
                  <input type="file" 
                  onChange={handleFile}
                  className="form-control" id="subir " />
                </div>
                <div className="card-footer d-flex justify-content-end py-6 px-9">
                  <button
                    type="submit"
                    className="btn btn-success fw-bold"
                    onClick={handleClick}
                    disabled={cargando}
                  >
                    {cargando ? " Finalizando..." : " Finalizar"}
                  </button>
                </div>
              </div>
      </Modal>
    </>
  );
};
